module.exports = __webpack_public_path__ + "img/mediastats.63648ea1.svg";